module.exports = __webpack_public_path__ + "img/engineer-logo-1.6a718447.png";